import { __assign, __values, __read } from 'tslib';

function formatParams(data) {
  var arr = [];
  for (var name_1 in data) {
    arr.push(encodeURIComponent(name_1) + '=' + encodeURIComponent(data[name_1]));
  }
  arr.push(('t=' + Math.random()).replace('.', ''));
  return arr.join('&');
}
function setHeaders(xhr, headers) {
  var e_1, _a;
  try {
    for (var _b = __values(Object.entries(headers)), _c = _b.next(); !_c.done; _c = _b.next()) {
      var _d = __read(_c.value, 2),
        header = _d[0],
        value = _d[1];
      xhr.setRequestHeader(header, value);
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
}
var ajax = function ajax(options) {
  if (typeof window !== 'undefined') {
    options = options || {};
    options.type = (options.type || 'GET').toUpperCase();
    options.dataType = options.dataType || 'json';
    options.headers = __assign(__assign({}, options.headers || {}), {
      'Bce-Long-Term-Session': 'True'
    });
    var params = options.data ? formatParams(options.data) : '';
    if (options.contentType && options.contentType === 'application/json') {
      params = JSON.stringify(options.data);
    }
    var getSendData = params ? '?' + params : '';
    if (options.dataType === 'jsonp') {
      var callbackName = options.success;
      var elem = document.createElement('script');
      elem.src = options.url + '?callback=' + callbackName;
      document.head.appendChild(elem);
    } else {
      var xhr_1 = null;
      // 创建 - 非IE6 - 第一步
      if (window.XMLHttpRequest) {
        xhr_1 = new XMLHttpRequest();
      } else if (window.ActiveXObject) {
        xhr_1 = new window.ActiveXObject('Microsoft.XMLHTTP');
      } else {
        xhr_1 = null;
        return;
      }
      // 是否携带cookie
      if (options.withCredentials) {
        xhr_1.withCredentials = true;
      }
      // 接收 - 第三步
      xhr_1.onreadystatechange = function () {
        if (Number(xhr_1.readyState) === 4) {
          var status_1 = xhr_1.status;
          if (status_1 >= 200 && status_1 < 300) {
            options.success && options.success(xhr_1.responseText, xhr_1.responseXML);
          } else {
            options.fail && options.fail(status_1);
          }
        }
      };
      // 连接 和 发送 - 第二步
      if (options.type === 'GET') {
        xhr_1.open('GET', options.url + getSendData, true);
        setHeaders(xhr_1, options.headers);
        xhr_1.send(null);
      } else if (options.type === 'POST') {
        xhr_1.open('POST', options.url, true);
        setHeaders(xhr_1, options.headers);
        // 设置表单提交时的内容类型
        xhr_1.setRequestHeader('Content-Type', options.contentType || 'application/x-www-form-urlencoded');
        xhr_1.send(params);
      }
    }
  }
};

export { ajax };
